import { Link } from 'react-router-dom';
import { scr } from '../../lib/api';
import type { Award, Page } from '../../lib/types';
import { useApiQuery } from '../../lib/useApi';
import { EmptyState, ErrorNote, PageHeader, Spinner, StatusBadge } from '../../ui/components';

/** Public awards register — no sign-in required. */
export function AwardsRegister() {
  const awardsQ = useApiQuery<Page<Award>>('/api/v1/m11/awards?limit=50');

  return (
    <div>
      <PageHeader title="Awards Register" subtitle="Every non-reversed procurement award, public by law." />
      {awardsQ.error ? <ErrorNote message={awardsQ.error} /> : null}
      <div className="card overflow-x-auto">
        {awardsQ.loading ? (
          <Spinner />
        ) : (awardsQ.data?.items.length ?? 0) === 0 ? (
          <EmptyState title="No awards yet" />
        ) : (
          <table className="w-full">
            <thead>
              <tr>
                <th className="table-head">Ref</th>
                <th className="table-head">Supplier</th>
                <th className="table-head text-right">Amount</th>
                <th className="table-head">Status</th>
                <th className="table-head">Proposed</th>
              </tr>
            </thead>
            <tbody>
              {awardsQ.data!.items.map((a) => (
                <tr key={a.id} className="hover:bg-slate-50">
                  <td className="table-cell font-mono text-xs">
                    <Link className="text-brand-600 hover:underline" to={`/procurement/awards/${a.id}`}>{a.refNo}</Link>
                  </td>
                  <td className="table-cell font-mono text-xs text-slate-500">{a.supplierId.slice(0, 16)}…</td>
                  <td className="table-cell text-right tabular-nums">{scr(a.amountScr)}</td>
                  <td className="table-cell"><StatusBadge status={a.status} /></td>
                  <td className="table-cell text-xs">{new Date(a.proposedAt).toLocaleDateString('en-GB')}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
